import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Observer, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { Socket } from 'src/app/shared/interfaces';
import { UtilsService } from './../_services/utils.service';

@Injectable({
  providedIn: 'root'
})

export class CashierService {
  socket: Socket;
  observer: Observer<number>;
  postMessageData: object;
  is_tournament: string;
  currentUser: any;
  user_id: number;
  drafters_id: string;
  league_id: number;

  constructor(private http: HttpClient,
    private router: Router, private _utilsService: UtilsService) {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (this.currentUser != null) {
      this.user_id = this.currentUser.id;
    }
  }

  cashierTickets(oauth_token, user_id): Observable<any> {
    return this._utilsService.getRequest(`${environment.phpApiUrl}` + '/tournament/cashier-tickets/' + oauth_token + '/' + user_id);
  }
  
  userData(oauth_token, user_id): Observable<any> {
    return this._utilsService.getRequest(`${environment.phpApiUrl}` + '/user/profile/' + oauth_token + '?page=cashier');
  }

  summaryInfo(user_id) {
    return this._utilsService.getRequest(`${environment.phpApiUrl}` + '/cashier/summary/' + `${environment.DRAFT_ACCESS_TOKEN}` +'/'+user_id);
  }

  addFunds(user_id) {
    return this._utilsService.getRequest(`${environment.phpApiUrl}` + '/cashier/add-funds/' + `${environment.DRAFT_ACCESS_TOKEN}` +'/'+user_id);
  }

  accountHistory(user_id,txn_action,cursor) {
    return this._utilsService.getRequest(`${environment.phpApiUrl}` + '/wallet/get-all/' + `${environment.DRAFT_ACCESS_TOKEN}` +'/'+user_id+'/'+txn_action+'/'+cursor+'/'+20);
  }

  getTickets(user_id) {
    return this._utilsService.getRequest(`${environment.phpApiUrl}` + '/tournament/cashier-tickets/' + `${environment.DRAFT_ACCESS_TOKEN}` +'/'+user_id);
  }

  pendingCashOut(user_id) {
    return this._utilsService.getRequest(`${environment.phpApiUrl}` + '/wallet/get-pending-item/' + `${environment.DRAFT_ACCESS_TOKEN}` +'/'+user_id);
  }
  
  stateList(country_id) {
    return this._utilsService.getRequest(`${environment.phpApiUrl}` + '/location/getStatesByCountry/' + `${environment.DRAFT_ACCESS_TOKEN}` +'/'+country_id);
  }

  deleteCashOutRequest(data): Observable<any> {
    return this._utilsService.postRequest(`${environment.phpApiUrl}` + '/cashier/cancel-request', data, null, 'content-type-json');
  }

  confirmCashOut(data): Observable<any> {
    return this._utilsService.postRequest(`${environment.phpApiUrl}` + '/cashier/cashout-confirm', data, null, 'content-type-json');
  }

  checkPromoCode(data): Observable<any> {
    return this._utilsService.postRequest(`${environment.phpApiUrl}` + '/cashier/check-promo-code', data, null, 'content-type-json');
  }

  checkPromoCodeByAmt(data): Observable<any> {
    return this._utilsService.postRequest(`${environment.phpApiUrl}` + '/promocode/check', data, null, 'content-type-json');
  }

  validatePaypal(data): Observable<any> {
    return this._utilsService.postRequest(`${environment.phpApiUrl}` + '/payment/validatePaypal', data, null, 'content-type-json');
  }
  
  savedCards(user_id) {
    return this._utilsService.getRequest(`${environment.phpApiUrl}` + '/cashier/saved-cards/' + `${environment.DRAFT_ACCESS_TOKEN}` +'/'+user_id);
  }
   
  deleteCards(data): Observable<any> {
    return this._utilsService.postRequest(`${environment.phpApiUrl}` + '/cashier/delete-cards', data, null, 'content-type-json');
  }
  
  addNewCard(data): Observable<any> {
    return this._utilsService.postRequest(`${environment.phpApiUrl}` + '/cashier/add-new-cards', data, null, 'content-type-json');
  }
  
  tsevoVerification(data): Observable<any> {
    return this._utilsService.postRequest(`${environment.phpApiUrl}` + '/cashier/tsevo_verification', data, null, 'content-type-json');
  }
  
  submitVerificationDocument(data): Observable<any> {
    return this._utilsService.postRequest(`${environment.adminUrl}` + '/cashierPopup/submit-verification-document', data, null);
  }
  
  checkPaypalPaymentStatus(payment_id) {
    return this._utilsService.getRequest(`${environment.phpApiUrl}` + '/payment/check-paypal-payment-status/' + `${environment.DRAFT_ACCESS_TOKEN}` +'/'+payment_id);
  }
  
  checkUserEligibility(data): Observable<any> {
    return this._utilsService.postRequest(`${environment.phpApiUrl}` + '/user/checkUserEligibility', data, null, 'content-type-json');
  }
  getFinancialReport(user_id,year): Observable<any> {
    let data = {'user_id':user_id,'year':year};
    return this._utilsService.postRequest(`${environment.phpApiUrl}` + '/wallet/get-financial-report', data, null, 'content-type-json');  }
  
  private handleError(error) {
    console.error('server error:', error);
    if (error.error instanceof Error) {
      const errMessage = error.error.message;
      return Observable.throw(errMessage);
    }
    return Observable.throw(error || 'Socket.io server error');
  }

  private handleErrorPost<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  sendPhoneOtp(phoneNumber): Observable<any> {
    const data = phoneNumber ? {phone_number : phoneNumber} :  {};
    return this._utilsService.postRequest(`${environment.phpApiUrl}/user/triggerPhoneOtp`, data, null);
  }

  kycVerification() {
    return this._utilsService.getRequest(`${environment.phpApiUrl}` + '/user/kyc-verification');
  }

  verficationInfo() {
    const url = `${environment.phpApiUrl}/user/profile/${environment.DRAFT_ACCESS_TOKEN}?page=verification`;
    return this._utilsService.getRequest(url);  
  }
}
